module.exports = __webpack_public_path__ + "media/packs/landing_page/images/header_img-836203479724bbee5ffd5c7653c1c533.jpg";